<template>
  <div :id="id" :style="{ width : width, height: height}" ref="chart"></div>
</template>
<script>
import $ from 'jquery'
import echarts from 'echarts';
import elementResizeDetectorMaker from 'element-resize-detector';
import platenLayoutEdit from '@/mixins/platenLayoutEdit'

export default {
  name: "chart",
  mixins: [platenLayoutEdit],
  props: {
    route: {
      type: String,
      default: ""
    },
    id: {
      type: String,
      default: "chart"
    },
    width: {
      type: String,
      default: "500px"
    },
    height: {
      type: String,
      default: "430px"
    },
    brick: {
      type: Boolean,
      default: false
    },
    option: {
      type: Object,
      // eslint-disable-next-line vue/require-valid-default-prop
      default: {}
    },
    extendData: null,
    spaceId: {
      type: String,
      default: null
    },
    tagId: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      myEcharts: null
    };
  },
  mounted() {
    if (this.option.series) {
      this.initCharts();
    }
  },
  methods: {
    initCharts() {
      const that = this
      this.$refs.chart.style.height = this.height;
      this.myEcharts = echarts.init(this.$refs.chart);
      const option = $.extend(true, this.option, this.extendData);
      this.myEcharts.setOption(option);
      this.resizeEcharts(this.$refs.chart, this.myEcharts)
      //点击前解绑，防止点击事件触发多次
      this.myEcharts.off('click');
      this.myEcharts.on('click', function (params) {
        console.log(params, "-------click");
        if (that.brick) {
          that.$emit('echartsMapClick', params)
        } else {
          if (params.seriesType === 'effectScatter') {
            that.option.series.map(item => {
              if (item.type === "lines") {
                item.data = [params.data]
              }
              return item;
            })
          } else {
            // 跳转到最后一个空间
            let space = null;
            if (params.data.citySpaceList) {
              space = params.data.citySpaceList[params.data.citySpaceList.length - 1].spaceList[params.data.citySpaceList[params.data.citySpaceList.length - 1].spaceList.length - 1];
            }
            console.log("跳转空间", space, params, params.name)
            
            // 如果是告警中心跳转 路由带上当前点击的日期
            if (that.route && that.route === "/realTime-alarm") {
              if (params.name !== '') {
                const levelId = params.data.id;
                that.toRouter(that.route + "?levelId=" +levelId, space)
              }
            } 
            // 如果是设备列表跳转，带上空间ID和设备类型
            else if (that.route && that.route === "/device-list") {
              const extraParams = {};
              
              // 添加空间ID
              if (that.spaceId) {
                extraParams.spaceId = that.spaceId;
              }
              
              // 添加设备类型（typeEngName）
              if (params.data.typeEngName) {
                extraParams.typeEngName = params.data.typeEngName;
              }
              
              that.toRouter(that.route, space, extraParams);
            }
            else if (that.route) {
              that.toRouter(that.route, space)
            }
          }
        }
      });
    },
    // 跳转路径
    toRouter(router, space, params) {
      if (this.isPlatenLayoutEditing) return
      console.log("路由跳转", router, space, params)
      
      let query = {};
      
      // 如果有空间信息
      if (space) {
        query.spaceId = space.id;
        query.spaceName = space.cnName;
      }
      
      // 如果是跳转到设备列表且有额外参数
      if (params) {
        query = { ...query, ...params };
      }
      
      this.$router.push({
        path: router,
        query: query
      })
    },
    /** 供父组件在布局变更后触发（如大屏 resizeCenterCharts） */
    resize() {
      if (this.myEcharts) {
        this.myEcharts.resize();
      }
    },
    resizeEcharts(echart, myChart) {
      // 监听id为echart的元素 大小变化
      elementResizeDetectorMaker().listenTo(echart, function () {
        // const width = element.offsetWidth
        // const height = element.offsetHeight
        // console.log(width,height,myChart,"==============");
        //使echarts尺寸重置
        myChart.resize();
      })
    }
  },
  watch: {
    //观察option的变化
    option: {
      handler() {
        if (this.myEcharts) {
          this.myEcharts.setOption(this.option);
        } else {
          this.initCharts();
        }
      },
      deep: true //对象内部属性的监听，关键。
    },
    height: {
      handler() {
        this.initCharts();
      }
    }
  }
};
</script>
